import React, {useState} from "react";
import Modal from "@amzn/meridian/modal";
import {injectIntl} from "react-intl";
import PageFooterModal from "../../../commonui/PageFooterModal";
import {
    validateAddAislesForLedController
} from "../../../util/Validations";
import Column from "@amzn/meridian/column";
import {CONFIG_TYPE} from "../../../util/Constants";
import AisleRangeInputModal from "./AisleRangeInputModal";
import {
    createNextAisleConfigs,
    getLastAisleConfig,
} from "../../../util/LEDControllerUtil";
import PropTypes from "prop-types";

const AddMultipleAisleRowsModal = (props) => {

    const {formatMessage} = props.intl;
    const {open, setOpen, getDraftData, setDraftData, mac, aisleTypes} = props;

    // Visual controls
    const [showAlert, setShowAlert] = useState(false)

    // States
    const [startAisle, setStartAisle] = useState(null)
    const [startPort, setStartPort] = useState(null);
    const [aisleCount, setAisleCount] = useState(null)
    const [aisleType, setAisleType] = useState(null)

    // Errors
    const [startAisleError, setStartAisleError] = useState(false)
    const [startPortError, setStartPortError] = useState(false)
    const [aisleCountError, setAisleCountError] = useState(false)
    const [aisleTypeError, setAisleTypeError] = useState(false)

    const stateValues = {
        ledControllerConfig: {
            startAisleLabel: startAisle,
            startPortNumber: startPort,
            aisleCount: aisleCount,
            aisleType: aisleType,
        }
    }

    const resetAssetDetails = () => {
        setStartAisle(null)
        setStartPort(null)
        setAisleCount(null)
        setAisleType(null)
    }

    const resetAssetDetailErrors = () => {
        setStartAisleError(false)
        setStartPortError(false)
        setAisleCountError(false)
    }

    const resetInputState = () => {
        resetAssetDetails()
        resetAssetDetailErrors()
    }

    const onCloseModal = () => {
        setOpen(false)
        resetAssetDetails()
        setShowAlert(false);
    }

    const addData = (aisleConfigs) => {
        setDraftData({
            data: aisleConfigs,
            stateKey: CONFIG_TYPE.LED_CONTROLLER_CONFIGURATION,
            subKey: mac,
            override: true
        })
    }

    const onClickConfirm = (stateValues) => {
        if (validateAddAislesForLedController(stateValues)) {
            setShowAlert(false)
            const lastAisleConfig = getLastAisleConfig(getDraftData())
            const nextAisleConfigs = createNextAisleConfigs(stateValues.ledControllerConfig,
                lastAisleConfig ? lastAisleConfig.index : 1)
            addData([...getDraftData(), ...nextAisleConfigs]);
            resetInputState();
            setOpen(false);
        } else {
            setShowAlert(true)
        }
    }

    return (
        <Modal
            title={formatMessage({id: "device.add_aisles_button_modal"})}
            open={open}
            onOpen={resetInputState}
            onClose={onCloseModal}
            scrollContainer="viewport"
            closeLabel="Close"
            bodySpacingInset="medium"
            width="100%">
            <Column spacing={"medium"} spacingInset={"medium"}>
                <AisleRangeInputModal startAisle={startAisle} setStartAisle={setStartAisle}
                                      startAisleError={startAisleError} setStartAisleError={setStartAisleError}
                                      startPort={startPort} setStartPort={setStartPort}
                                      startPortError={startPortError} setStartPortError={setStartPortError}
                                      aisleCount={aisleCount} setAisleCount={setAisleCount}
                                      aisleCountError={aisleCountError} setAisleCountError={setAisleCountError}
                                      aisleType={aisleType} setAisleType={setAisleType}
                                      aisleTypeError={aisleTypeError} setAisleTypeError={setAisleTypeError}
                                      getAisleTypeOptions={aisleTypes}
                                      stateValues={stateValues}
                />
            </Column>
            {<PageFooterModal showAlert={showAlert} onCloseModalCallBack={onCloseModal}
                          onClickConfirmCallBack={() => onClickConfirm(stateValues)}
            />}
        </Modal>
    )
}

AddMultipleAisleRowsModal.propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired
    }).isRequired,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    getDraftData: PropTypes.func.isRequired,
    setDraftData: PropTypes.func.isRequired,
    mac: PropTypes.string.isRequired,
    aisleTypes: PropTypes.array.isRequired
};

export default injectIntl(AddMultipleAisleRowsModal);


// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/modal/AddMultipleAisleRowsModal.js